import { DOCUMENT } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { MainHubService } from "../../services/main-hub.service";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { ApiRestService } from "src/app/services/apirestservice.service";
import { of } from "rxjs";
import { AmeritradeSymbolQuotesResponse } from "src/app/Models/AmeritradeSymbolQuotesResponse";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
})
export class HomeComponent {
  addSymbolForm: FormGroup = new FormGroup({
    symbolName: new FormControl("", Validators.required),
  });

  public QuoteData;

  constructor(
    public mainHubService: MainHubService,
    private router: Router,
    private restService: ApiRestService,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.getData();
  }

  async login() {
    this.mainHubService.login("admin", "admin");
  }

  async goToAmeritradeLogin() {
    this.document.location.href =
      await this.mainHubService.getAmeritradeReturnUrl();
  }

  getData() {
    this.restService.getStocks().subscribe(async (v) => {
      this.QuoteData = Object.values(v);
      await delay(100000);
      this.getData();
    });
  }

  public navigate(symbol: any) {
    this.router.navigate(["/possible-trades", symbol]);
  }

  async onAddSymbol() {
    await this.mainHubService.addSymbol(
      this.addSymbolForm.controls["symbolName"].value
    );
  }

  async onRemoveSymbol(symbolName: string) {
    if (confirm(`Are you sure you want to remove ${symbolName}?`)) {
      await this.mainHubService.removeSymbol(symbolName);
    }
  }
}

function delay(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
